import { render, staticRenderFns } from "./EditTextAlfanumerico.vue?vue&type=template&id=b14b4cca&scoped=true"
import script from "./EditTextAlfanumerico.vue?vue&type=script&lang=js"
export * from "./EditTextAlfanumerico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14b4cca",
  null
  
)

export default component.exports